import { createSlice } from "@reduxjs/toolkit";

const aitsTestSlice = createSlice({
  name: "aitsTests",
  initialState: {
    loading: false,
    error: null,
    tabs: [],
    list: [],
  },
  reducers: {
    fetchAitsTestListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAitsTestListSuccess: (state, action) => {
      state.loading = false;
      state.tabs = action.payload.tabs;
      state.list = action.payload.list;
    },
    fetchAitsTestListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});


export const {
  fetchAitsTestListRequest,
  fetchAitsTestListSuccess,
  fetchAitsTestListFailure,
} = aitsTestSlice.actions;

export default aitsTestSlice.reducer;


